import * as types from './types';

export default {
  // change loading state
  [types.LOADING_START](state) {
    state.loading.nb += 1;
    state.loading.isVisible = true;
  },
  [types.LOADING_FINISH](state) {
    state.loading.nb -= 1;
    if (state.loading.nb === 0) {
      state.loading.isVisible = false;
    }
  },
  [types.SET_LAST_BREADCRUMB](state, payload) {
    payload.route.meta.breadcrumbs[payload.route.meta.breadcrumbs.length - 1].name = payload.name;
  },
  // open snackbar
  [types.DISPLAY_ERROR_OPEN](state, params) {
    // check if snack bar must be centered
    if (params.centered === undefined) {
      state.snackbar.centered = true;
    } else {
      state.snackbar.centered = params.centered;
    }
    if (params.type === undefined) {
      state.snackbar.type = 'info';
    } else {
      state.snackbar.type = params.type;
    }
    // check if a snack bar is already opened
    state.snackbar.message = params.text;
    state.snackbar.isVisible = true;
  },
  // close snackbar
  [types.DISPLAY_ERROR_CLOSE](state) {
    state.snackbar.isVisible = false;
  },
  // reset snackbar posiiton to left
  [types.RESET_SNACKBAR](state) {
    state.snackbar.centered = false;
  },
  [types.SET_IS_MOBILE](state, value) {
    state.isMobile = value;
  },
  [types.UPDATE_RESPONSIVE](state, docWidth) {
    const [smPoint, mdPoint, lgPoint, xlPoint] = [600, 900, 1200, 1800];
    function between(min, max) {
      return min <= docWidth && docWidth < max;
    }
    Object.assign(state.responsive, {
      xs: docWidth < smPoint,
      sm: docWidth >= smPoint,
      md: docWidth >= mdPoint,
      lg: docWidth >= lgPoint,
      xl: docWidth >= xlPoint,
      only: {
        xs: docWidth < smPoint,
        sm: between(smPoint, mdPoint),
        md: between(mdPoint, lgPoint),
        lg: between(lgPoint, xlPoint),
        xl: docWidth >= xlPoint,
      },
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/application/mutations.js